import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { KwTableRow } from '../../kw-ui-components/KwTableRow';

// based on https://stackoverflow.com/a/64789744
interface TableRowLinkProps {
  href?: string;
  uniqueId: string;
  children: JSX.Element[];
  ariaLabel: string;
}

export const TableRowLink = ({ href, uniqueId, children, ariaLabel }: TableRowLinkProps) => {
  if (!href) {
    return (
      <KwTableRow tabIndex={0} aria-label={ariaLabel} aria-describedby={uniqueId}>
        {children}
      </KwTableRow>
    );
  }

  return (
    <KwTableRow tabIndex={0} aria-label={ariaLabel} aria-describedby={uniqueId} style={{ position: 'relative', cursor: 'pointer' }}>
      <StyledHiddenLink to={href} tabIndex={-1} id={uniqueId}>
        {children}
      </StyledHiddenLink>
    </KwTableRow>
  );
};

const StyledHiddenLink = styled(Link)`
  display: contents;
`;
